// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2lCEw","productName":"Table_productName__1cQm6"};